<template>
  <v-dialog
    :value="isConfigurarSecaoDialogOpen"
    max-width="700px"
    persistent
  >
    <v-card class="pa-sm-8 pa-2">
      <btn-close-dialog :handle-click="isSecaoNova ? resetFormAndCloseDialog : closeDialog"></btn-close-dialog>

      <v-card-title class="justify-center text-h5">
        {{ tituloDialog }}
      </v-card-title>

      <v-card-text class="mt-5">
        <v-form
          ref="formRef"
          class="multi-col-validation"
          @submit.prevent="handleSubmit"
        >
          <v-row>
            <v-col
              v-if="podeDefinirTitulo"
              cols="12"
            >
              <v-text-field
                v-model="secaoDataLocale.titulo"
                outlined
                dense
                clearable
                validate-on-blur
                label="Título:"
                counter="50"
                hint="Máximo de 50 caracteres"
                persistent-hint
                :rules="[validators.required]"
                :append-icon="icons.mdiFormatText"
              />
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="secaoDataLocale.linhas"
                outlined
                dense
                label="Número de linhas:"
                :items="linhasOptions"
                :rules="[validators.select]"
              />
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="secaoDataLocale.colunas"
                outlined
                dense
                label="Número de colunas:"
                :items="colunasOptions"
                :rules="[validators.select]"
              />
            </v-col>
          </v-row>

          <v-row class="mt-5">
            <v-col
              cols="12"
              class="d-flex justify-center"
            >
              <v-btn
                outlined
                color="secondary"
                class="mr-3"
                :disabled="loading"
                @click="isSecaoNova ? resetFormAndCloseDialog() : closeDialog()"
              >
                Cancelar
              </v-btn>

              <v-btn
                color="primary"
                type="submit"
              >
                <v-progress-circular
                  v-if="loading"
                  class="mx-3"
                  indeterminate
                  color="secundary"
                />
                <span v-else>Salvar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import { ref, watch, computed } from '@vue/composition-api'
import { mdiFormatText, mdiArrowSplitHorizontal, mdiArrowSplitVertical } from '@mdi/js'
import { required, select } from '@core/utils/validation'
import router from '@/router'
import BtnCloseDialog from '@/components/btn-close-dialog/BtnCloseDialog.vue'
import TiposDeSecoesEnum from '@/models/entities/formulario/secao/TiposDeSecoesEnum'
import FormularioService from '@/services/modules/FormularioService'

export default {
  components: {
    BtnCloseDialog,
  },

  props: {
    isConfigurarSecaoDialogOpen: {
      type: Boolean,
      required: true,
    },
    secaoData: {
      type: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const secaoDataLocale = ref({})
    watch(() => props.secaoData, newValue => { secaoDataLocale.value = JSON.parse(JSON.stringify(newValue)) }, { immediate: true, deep: true })

    const linhasOptions = ref([...Array(25).keys()].map(n => n + 1))
    const colunasOptions = ref([...Array(5).keys()].map(n => n + 1))

    const isSecaoMensagens = computed(() => secaoDataLocale.value.idSecaoTipo === TiposDeSecoesEnum.Mensagens)
    const isSecaoDadosCliente = computed(() => secaoDataLocale.value.idSecaoTipo === TiposDeSecoesEnum.DadosDoCliente)
    const isSecaoDefault = computed(() => isSecaoMensagens.value || isSecaoDadosCliente.value)

    const isSecaoNova = computed(() => secaoDataLocale.value.id === 0)
    const podeDefinirTitulo = computed(() => !isSecaoDefault.value)
    const tituloDialog = computed(() => (isSecaoNova.value && !isSecaoDefault.value ? 'Criar seção' : 'Configurar seção'))

    const formRef = ref(null)
    const loading = ref(false)
    function resetForm() {
      formRef.value.reset()
    }
    function closeDialog() {
      emit('update:is-configurar-secao-dialog-open', false)
    }
    function resetFormAndCloseDialog() {
      resetForm()
      closeDialog()
    }

    function resetData() {
      secaoDataLocale.value.titulo = props.secaoData.titulo
      secaoDataLocale.value.linhas = props.secaoData.linhas
      secaoDataLocale.value.colunas = props.secaoData.colunas
    }
    function errorCallback() {
      resetData()
      loading.value = false
    }

    async function criarSecao() {
      try {
        loading.value = true
        await FormularioService.criarSecao(router.currentRoute.params.id, secaoDataLocale.value)
        loading.value = false
        emit('secao-criada')
        resetFormAndCloseDialog()
      } catch {
        errorCallback()
      }
    }
    async function atualizarSecao() {
      try {
        loading.value = true
        await FormularioService.atualizarSecao(router.currentRoute.params.id, secaoDataLocale.value.id, secaoDataLocale.value)
        loading.value = false
        emit('refetch-data')
        closeDialog()
      } catch {
        errorCallback()
      }
    }
    async function handleSubmit() {
      if (loading.value) return
      if (formRef.value.validate() && isSecaoNova.value) {
        await criarSecao()
      } else if (formRef.value.validate() && !isSecaoNova.value) {
        await atualizarSecao()
      } else {
        Vue.$toast.warning('Preencha corretamente os campos antes de salvar')
      }
    }

    return {
      secaoDataLocale,
      linhasOptions,
      colunasOptions,
      isSecaoDefault,
      isSecaoNova,
      podeDefinirTitulo,
      tituloDialog,
      formRef,
      loading,
      closeDialog,
      resetFormAndCloseDialog,
      handleSubmit,
      icons: {
        mdiFormatText,
        mdiArrowSplitHorizontal,
        mdiArrowSplitVertical,
      },
      validators: {
        required,
        select,
      },
    }
  },
}
</script>
